@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-2 py-4" [class.embedded]="$isEmbedded()" [class.edocs]="$isEdocs()">
        <!-- Loading -->
        <ngx-spinner name="flowInstance" bdColor="#000000aa" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="true">
            <h5>Processando...</h5>
        </ngx-spinner>

        <div class="container-flex d-flex flex-column align-items-center">
            <div class="announcements-container" [class.mb-4]="$visibleAnnouncements() > 0">
                @for (announcement of $announcements(); track announcement) {
                    <announcer class="mb-1"
                               [_title]="announcement.title"
                               [_message]="announcement.message"
                               [_level]="announcement.level"
                               (_isVisibleEvent)="$visibleAnnouncements.set($visibleAnnouncements() - 1)"
                    ></announcer>
                }
            </div>

            <div class="card instance-area">
                @if ($isFlowInstanceRelatedToUser() === false) {
                    <!-- Usuário sem permissão -->
                    <div class="message h4">
                        <b>Você não possui permissão para acessar este Fluxo!</b>
                    </div>
                } @else if ($isFlowInstanceRelatedToUser() === true) {
                    @if ($isInstanceResultOnly()) {
                        <!-- FlowInstance Result -->
                        <div class="instance-area result-only card">
                            @if ($isEmbedded()) {
                                <!-- Name tag -->
                                <div class="name-tag-wrapper">
                                    <div class="name-tag-container">
                                        <span class="name-tag-label">
                                            <i class="fas fa-user mr-1"></i>
                                            Você está logado como
                                        </span>
                                        <span class="name-tag">
                                            {{$currentUser().nome}}
                                        </span>
                                    </div>
                                </div>
                            }

                            <!-- Header -->
                            <div class="header">
                                <!-- Title -->
                                <div class="title">
                                    <!-- Breadcrumb -->
                                    @if (!$isFromConecta() && !$isEmbedded() && !$isEdocs()) {
                                        <a [routerLink]="[Enums.PagesPaths.FlowInstanceList]"><span>Meus Fluxos</span></a>
                                        <i class="fas fa-chevron-right mx-1"></i>
                                    }

                                    <!-- Nome -->
                                    <div class="flow-instance-name">
                                        <span class="m-0"
                                              [class.h5]="!$isEmbedded()"
                                              [class.text-highlight]="!$isEmbedded()"
                                        >{{$model().name}}</span>
                                    </div>
                                </div>

                                <!-- Tags -->
                                <div class="tags">
                                    @if ($patriarchAcronym() != null && $organizationAcronym() != null && $unitAcronym() != null) {
                                        <!-- Caixa de Fluxos -->
                                        <span class="flow-inbox info-font text-highlight"
                                              matTooltip="Setor responsável pelo Fluxo: {{$patriarchAcronym()}} - {{$organizationAcronym()}} - {{$unitAcronym()}}"
                                        >{{$patriarchAcronym()}} - {{$organizationAcronym()}} - {{$unitAcronym()}}</span>
                                    }

                                    <!-- Versão -->
                                    <span class="version-tag px-1 py-0" matTooltip="Versão instanciada">Versão {{$model().version}}</span>
                                </div>
                            </div>

                            <!-- Canvas -->
                            <div class="task-area card">
                                <!-- Header -->
                                <div class="task-header" [class.px-1]="!$isEmbedded()">
                                    <div class="first-group">
                                        <h5 class="task-name">
                                            Fluxo Encerrado
                                        </h5>
                                    </div>
                                </div>

                                @if (!$isEmbedded()) {
                                    <hr class="task-header-separator" #taskHeaderSeparatorRef />
                                }

                                <!-- Body -->
                                <div class="task-container" #taskContainerRef>
                                    @if ($isBootstrapFinished()) {
                                        <div class="wrapper px-2" #wrapperRef>
                                            @switch ($flowObjectInstanceResultOnly().flowObjectDefinition.typeId) {
                                                @case (FlowObjectType.Finish) {
                                                    <fob-finish [_model]="$flowObjectInstanceResultOnly()"
                                                                [_flowInstance]="$model()"
                                                                [_flowDefinition]="$model().flowDefinition"
                                                    ></fob-finish>
                                                }
                                                @case (FlowObjectType.FinishOutboundApi) {
                                                    <fob-outbound-api [_model]="$flowObjectInstanceResultOnly()"
                                                                      [_flowInstance]="$model()"
                                                                      [_flowDefinition]="$model().flowDefinition"
                                                                      (_modelChangeEvent)="outboundApiChangeHandler($event)"
                                                    ></fob-outbound-api>
                                                }
                                                @case (FlowObjectType.FinishContent) {
                                                    <fob-finish-content [_model]="$flowObjectInstanceResultOnly()"
                                                                        [_flowInstance]="$model()"
                                                                        [_flowDefinition]="$model().flowDefinition"
                                                                        (_submitEvent)="executeTask($event)"
                                                    ></fob-finish-content>
                                                }
                                            }
                                        </div>
                                    }
                                </div>

                                @if ($isBootstrapFinished()) {
                                    <!-- Botão para redirecionar a /flow-instance -->
                                    <div class="btn-flow-instance-container mt-2">
                                        <hr class="w-100"/>

                                        <div class="btn btn-outline-primary" (click)="redirectToFlowInstance(true)" (keyDown)="redirectToFlowInstance(true)">
                                            <i class="fas fa-list-ol mr-2"></i>
                                            <span>Acessar o Fluxo completo</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    } @else {
                        @if ($isEmbedded()) {
                            <!-- Name tag -->
                            <div class="name-tag-wrapper">
                                <div class="name-tag-container">
                                    <span class="name-tag-label">
                                        <i class="fas fa-user mr-1"></i>
                                        Você está logado como
                                    </span>
                                    <span class="name-tag">
                                        {{$currentUser().nome}}
                                    </span>
                                </div>
                            </div>
                        }

                        <!-- Header -->
                        <div class="header">
                            <!-- Title -->
                            <div class="title">
                                <!-- Breadcrumb -->
                                @if (!$isFromConecta() && !$isEmbedded() && !$isEdocs()) {
                                    <a [routerLink]="[Enums.PagesPaths.FlowInstanceList]"><span>Meus Fluxos</span></a>
                                    <i class="fas fa-chevron-right mx-1"></i>
                                }

                                <!-- Nome -->
                                <div class="flow-instance-name">
                                    <span class="m-0"
                                          [class.h5]="!$isEmbedded()"
                                          [class.text-highlight]="!$isEmbedded()"
                                    >{{$model().name}}</span>
                                </div>
                            </div>

                            <!-- Tags -->
                            <div class="tags">
                                @if ($patriarchAcronym() != null && $organizationAcronym() != null && $unitAcronym() != null) {
                                    <!-- Caixa de Fluxos -->
                                    <span class="flow-inbox info-font text-highlight"
                                          matTooltip="Setor responsável pelo Fluxo: {{$patriarchAcronym()}} - {{$organizationAcronym()}} - {{$unitAcronym()}}"
                                    >{{$patriarchAcronym()}} - {{$organizationAcronym()}} - {{$unitAcronym()}}</span>
                                }

                                <!-- Versão -->
                                <span class="version-tag px-1 py-0" matTooltip="Versão instanciada">Versão {{$model().version}}</span>
                            </div>
                        </div>

                        @if (!$isEmbedded()) {
                            <hr />
                        }

                        @if (!$isEmbedded() && Utils.isNotNullOrEmpty($model().flowDefinition?.publishedDescription)) {
                            <!-- Descrição e Informações -->
                            <div class="description-area card mx-1 mt-2 mb-4" #descriptionAreaRef
                                 [class.show]="$isShowingDescription()"
                            >
                                <div class="description-tag info-font" (click)="toggleDescription()" (keyDown)="toggleDescription()">
                                    <i class="toggle-description fas fa-chevron-circle-right mr-1" [class.on]="$isShowingDescription()"></i>
                                    <span>Descrição e Informações</span>
                                    <i class="toggle-description fas fa-chevron-circle-left ml-1" [class.on]="$isShowingDescription()"></i>
                                </div>

                                <div class="description-message-container" [class.show]="$isShowingDescription()">
                                    <div class="description-message" #descriptionMessageRef
                                         [hidden]="!$isShowingDescription()"
                                         [safeHtmlContent]="getDescriptionHtml()"
                                    ></div>
                                </div>
                            </div>
                        }

                        <!-- Canvas -->
                        @for (flowObjectInstance of $drawableFlowObjectInstances(); track flowObjectInstance; let i = $index) {
                            <div class="task-area card mx-1 mb-1" [class.hidden-ish]="shouldKeepTaskBodyClosed(i, flowObjectInstance)">
                                <!-- Ordem de execução da Tarefa -->
                                @if (
                                    flowObjectInstance.flowObjectDefinition.typeId != FlowObjectType.CancelByDeliberation
                                    && flowObjectInstance.flowObjectDefinition.typeId != FlowObjectType.CancelBySchedule
                                ) {
                                    <div class="task-order" matTooltip="Ordem de execução da Tarefa: {{i + 1}}">
                                        <span class="d-inline-block">{{i + 1}}</span>
                                    </div>
                                }

                                <!-- Header -->
                                <div class="task-header"
                                     [class.px-1]="!$isEmbedded()"
                                     [matTooltip]="$isEmbedded() ? 'Clique para exibir ou esconder detalhes sobre a Tarefa' : ''"
                                     (click)="$isEmbedded() ? (shouldNotShowTaskBody(flowObjectInstance) ? return : toggleTaskBody($event)) : return"
                                     (keyDown)="$isEmbedded() ? (shouldNotShowTaskBody(flowObjectInstance) ? return : toggleTaskBody($event)) : return"
                                >
                                    <div class="first-group">
                                        @if (!$isEmbedded()) {
                                            <!-- Ícone da Tarefa -->
                                            <div class="task-icon-container mr-2"
                                                 matTooltip="Tarefa de {{FlowObjectTypeCategory.get(+flowObjectInstance.flowObjectDefinition.typeId)}}"
                                                 (click)="shouldNotShowTaskBody(flowObjectInstance) ? return : toggleTaskBody($event)"
                                                 (keyDown)="shouldNotShowTaskBody(flowObjectInstance) ? return : toggleTaskBody($event)"
                                            >
                                                @switch (flowObjectInstance.flowObjectDefinition.typeId) {
                                                    @case (FlowObjectType.StartForm) {
                                                        <i class="fas fa-file-alt"></i>
                                                    }
                                                    @case (FlowObjectType.StartInboundApi) {
                                                        <i class="fas fa-external-link-square-alt"></i>
                                                    }
                                                    @case (FlowObjectType.TaskForward) {
                                                        <i class="fas fa-paper-plane"></i>
                                                    }
                                                    @case (FlowObjectType.TaskAcknowledge) {
                                                        <i class="fas fa-check"></i>
                                                    }
                                                    @case (FlowObjectType.TaskMidwayOutboundApi) {
                                                        <i class="fas fa-external-link-alt"></i>
                                                    }
                                                    @case (FlowObjectType.TaskRegisterProcess) {
                                                        <i class="fas fa-suitcase"></i>
                                                    }
                                                    @case (FlowObjectType.TaskDispatchProcess) {
                                                        <i class="fas fa-forward"></i>
                                                    }
                                                    @case (FlowObjectType.TaskAddToProcess) {
                                                        <i class="fas fa-file-import"></i>
                                                    }
                                                    @case (FlowObjectType.GatewayApprove) {
                                                        <i class="fas fa-thumbs-up"></i>
                                                    }
                                                    @case (FlowObjectType.GatewayRules) {
                                                        <i class="icon fas fa-gavel"></i>
                                                    }
                                                    @case (FlowObjectType.GatewayPaths) {
                                                        <i class="icon fas fa-random"></i>
                                                    }
                                                    @case (FlowObjectType.Finish) {
                                                        <i class="fas fa-stop-circle"></i>
                                                    }
                                                    @case (FlowObjectType.FinishOutboundApi) {
                                                        <i class="fas fa-external-link-alt"></i>
                                                    }
                                                    @case (FlowObjectType.FinishContent) {
                                                        <i class="fas fa-file-alt"></i>
                                                    }
                                                    @case (FlowObjectType.CancelByDeliberation) {
                                                        <i class="fas fa-solid fa-ban"></i>
                                                    }
                                                    @case (FlowObjectType.CancelBySchedule) {
                                                        <i class="fas fa-solid fa-ban"></i>
                                                    }
                                                }
                                            </div>
                                        }

                                        <!-- Nome da Tarefa -->
                                        <h6 class="task-name"
                                            (click)="!$isEmbedded() ? (shouldNotShowTaskBody(flowObjectInstance) ? return : toggleTaskBody($event)) : return"
                                            (keyDown)="!$isEmbedded() ? (shouldNotShowTaskBody(flowObjectInstance) ? return : toggleTaskBody($event)) : return"
                                        >
                                            {{flowObjectInstance.flowObjectDefinition?.publicName || flowObjectInstance.flowObjectDefinition?.name}}
                                        </h6>

                                        <!-- Expande/recolhe -->
                                        @if (!shouldNotShowTaskBody(flowObjectInstance)) {
                                            <i class="toggle-body fas"
                                                [ngClass]="!$isEmbedded() ? 'fa-chevron-circle-right' : 'fa-chevron-right'"
                                                [class.on]="!shouldKeepTaskBodyClosed(i, flowObjectInstance)"
                                                (click)="!$isEmbedded() ? toggleTaskBody($event) : return"
                                                (keyDown)="!$isEmbedded() ? toggleTaskBody($event) : return"
                                            ></i>
                                        }

                                        <!-- Mouseover info -->
                                        <ng-container>
                                            <i class="toggle-info fas fa-info-circle" [class.timer-on]="$showStartInboundApiTaskTimer()"
                                               matTooltip="Expandir/recolher informações sobre a Tarefa"
                                               (click)="toggleHeaderInfo($event)"
                                               (keyDown)="toggleHeaderInfo($event)"
                                            ></i>

                                            @if ($showStartInboundApiTaskTimer()) {
                                                <i class="toggle-info fas fa-clock"
                                                   matTooltip="Expandir/recolher informações sobre a Tarefa"
                                                   (click)="toggleHeaderInfo($event)"
                                                   (keyDown)="toggleHeaderInfo($event)"
                                                ></i>
                                            }
                                        </ng-container>
                                    </div>

                                    <div class="second-group display-none hidden-ish" #secondGroupRef>
                                        @if (Utils.isNotNullOrEmpty(flowObjectInstance.finisherInfo)) {
                                            <!-- Usuário executor da Tarefa -->
                                            <div class="finisher-info-container">
                                                @if (
                                                    flowObjectInstance.stateId != FlowObjectInstanceState.AutomaticallyCancelled
                                                    && flowObjectInstance.flowObjectDefinition.typeId != FlowObjectType.CancelBySchedule
                                                ) {
                                                    @if (!$isEmbedded()) {
                                                        <i class="fas fa-user-check" matTooltip="Usuário que executou a Tarefa"></i>
                                                    }

                                                    <span [ngClass]="{ 'info-font text-highlight': !$isEmbedded() }"
                                                          [matTooltip]="flowObjectInstance.finisherInfo"
                                                    >
                                                        {{flowObjectInstance.finisherInfo}}
                                                    </span>
                                                } @else {
                                                    @if (!$isEmbedded()) {
                                                        <i class="fas fa-cog" matTooltip="Tarefa executada pelo sistema"></i>
                                                    }

                                                    <span class="info-font text-highlight" [matTooltip]="flowObjectInstance.finisherInfo">
                                                        <span>&#9658;</span>
                                                        {{flowObjectInstance.finisherInfo}}
                                                        <span>&#9668;</span>
                                                    </span>
                                                }
                                            </div>
                                        }

                                        @if ($showStartInboundApiTaskTimer()) {
                                            <!-- Contagem regressiva para a execução da Tarefa -->
                                            <div class="timer-container mr-2" [class.time-up]="$startInboundApiTimer() == '00:00'">
                                                <i class="fas fa-clock mr-1"></i>

                                                <div class="d-inline-block"
                                                     matTooltip="Tempo aproximado restante para executar a Tarefa. Após este tempo, a instância do Fluxo será deletada
                                                                 e será necessário iniciar nova instância a partir do sistema que o redirecionou para o E-Flow"
                                                >{{$startInboundApiTimer()}}</div>
                                            </div>
                                        }

                                        <!-- Situação da Tarefa -->
                                        @if (
                                            flowObjectInstance.flowObjectDefinition.typeId != FlowObjectType.CancelByDeliberation
                                            && flowObjectInstance.flowObjectDefinition.typeId != FlowObjectType.CancelBySchedule
                                        ) {
                                            <div class="chip-container">
                                                @if (!$isEmbedded()) {
                                                    <i class="task-state fas fa-history" matTooltip="Situação da Tarefa"></i>
                                                }

                                                @let mt1 = FlowObjectInstanceStateDescription.get(+flowObjectInstance.stateId)
                                                    + ' em ' + getDateString(flowObjectInstance)
                                                    + ($isEmbedded() && Utils.isNotNullOrEmpty(flowObjectInstance.finisherInfo)
                                                        ? 'por ' + flowObjectInstance.finisherInfo
                                                        : ''
                                                    );
                                                <mat-chip-list class="d-inline-block" [matTooltip]="mt1">
                                                    <mat-chip selected [ngClass]="{
                                                        'started': flowObjectInstance.stateId == FlowObjectInstanceState.Started,
                                                        'finished': [
                                                            FlowObjectInstanceState.Finished,
                                                            FlowObjectInstanceState.ManuallyFinished
                                                        ].includes(flowObjectInstance.stateId),
                                                        'cancelled': [
                                                            FlowObjectInstanceState.AutomaticallyCancelled,
                                                            FlowObjectInstanceState.ManuallyCancelled,
                                                            FlowObjectInstanceState.CancelledByDeliberation
                                                        ].includes(flowObjectInstance.stateId),
                                                        'awaiting': FlowObjectInstanceState.AwaitingAction == flowObjectInstance.stateId
                                                    }">
                                                        {{FlowObjectInstanceStateDescription.get(+flowObjectInstance.stateId)}}
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </div>
                                        }
                                    </div>
                                </div>

                                @if (!$isEmbedded()) {
                                    <hr class="task-header-separator" #taskHeaderSeparatorRef
                                        [class.d-none]="shouldKeepTaskBodyClosed(i, flowObjectInstance)"
                                    />
                                }

                                <!-- Body -->
                                <div class="task-container" #taskContainerRef
                                     [class.d-none]="shouldKeepTaskBodyClosed(i, flowObjectInstance)"
                                     [class.hidden-ish]="shouldKeepTaskBodyClosed(i, flowObjectInstance)"
                                >
                                    <!-- Loading -->
                                    <ngx-spinner name="executing" bdColor="#fbfbfb" size="medium" color="#388fad" type="line-scale-pulse-out-rapid" [fullScreen]="false">
                                        <h6>Processando...</h6>
                                    </ngx-spinner>
                                    <ngx-spinner bdColor="transparent" size="medium" color="#388fad" type="line-scale-pulse-out-rapid" [fullScreen]="false">
                                        <h6>Processando...</h6>
                                    </ngx-spinner>

                                    @if ($startInboundApiTimer() == '00:00') {
                                        <!-- Mensagem de contagem regressiva esgotada -->
                                        <div class="timeout-message">
                                            <p>
                                                <i class="fas fa-clock mr-2"></i>
                                                <span>Tempo para a execução da Tarefa esgotado!</span>
                                            </p>
                                            <span>Acesse o sistema que o redirecionou para o E-Flow e inicie um novo procedimento de redirecionamento.</span>
                                        </div>
                                    } @else {
                                        @if ($isBootstrapFinished()) {
                                            <!-- Switch do tipo de Tarefa a ser desenhada -->
                                            <div class="wrapper px-2" #wrapperRef
                                                 [class.forced-show]="
                                                    flowObjectInstance.flowObjectDefinition.typeId == FlowObjectType.CancelByDeliberation
                                                    || flowObjectInstance.flowObjectDefinition.typeId == FlowObjectType.CancelBySchedule
                                                 "
                                            >
                                                @switch (flowObjectInstance.flowObjectDefinition.typeId) {
                                                    @case (FlowObjectType.StartForm) {
                                                        <fob-form [_flowObjectInstance]="flowObjectInstance"
                                                                  [_flowDefinition]="$model().flowDefinition"
                                                        ></fob-form>
                                                    }
                                                    @case (FlowObjectType.StartInboundApi) {
                                                        <fob-start-inbound-api [_flowObjectInstance]="flowObjectInstance"
                                                                               [_flowObjectDefinition]="flowObjectInstance.flowObjectDefinition"
                                                                               [_flowInstance]="$model()"
                                                                               [_flowDefinition]="$model().flowDefinition"
                                                                               (_submitEvent)="executeTask($event)"
                                                        ></fob-start-inbound-api>
                                                    }
                                                    @case (FlowObjectType.TaskForward) {
                                                        <fob-forward [_model]="flowObjectInstance"
                                                                     [_flowInstance]="$model()"
                                                        ></fob-forward>
                                                    }
                                                    @case (FlowObjectType.TaskAcknowledge) {
                                                        <fob-acknowledge [_model]="flowObjectInstance"
                                                                         [_flowInstance]="$model()"
                                                                         [_flowDefinition]="$model().flowDefinition"
                                                                         (_submitEvent)="executeTask($event)"
                                                        ></fob-acknowledge>
                                                    }
                                                    @case (FlowObjectType.TaskMidwayOutboundApi) {
                                                        <fob-midway-outbound-api [_model]="flowObjectInstance"
                                                                                 (_modelChangeEvent)="outboundApiChangeHandler($event)"
                                                        ></fob-midway-outbound-api>
                                                    }
                                                    @case (FlowObjectType.TaskRegisterProcess) {
                                                        <fob-register-process [_model]="flowObjectInstance"
                                                                              [_flowInstance]="$model()"
                                                                              [_flowDefinition]="$model().flowDefinition"
                                                                              (_submitEvent)="executeTask($event)"
                                                                              (_cancelFlowInstanceEvent)="$isCancelFromImpedingTask.set($event)"
                                                        ></fob-register-process>
                                                    }
                                                    @case (FlowObjectType.TaskDispatchProcess) {
                                                        <fob-dispatch-process [_model]="flowObjectInstance"
                                                                              [_flowInstance]="$model()"
                                                                              [_flowDefinition]="$model().flowDefinition"
                                                                              (_submitEvent)="executeTask($event)"
                                                                              (_cancelFlowInstanceEvent)="$isCancelFromImpedingTask.set($event)"
                                                        ></fob-dispatch-process>
                                                    }
                                                    @case (FlowObjectType.TaskAddToProcess) {
                                                        <fob-add-to-process [_model]="flowObjectInstance"
                                                                            [_flowInstance]="$model()"
                                                                            [_flowDefinition]="$model().flowDefinition"
                                                                            (_submitEvent)="executeTask($event)"
                                                                            (_cancelFlowInstanceEvent)="$isCancelFromImpedingTask.set($event)"
                                                        ></fob-add-to-process>
                                                    }
                                                    @case (FlowObjectType.GatewayApprove) {
                                                        <fob-approve [_model]="flowObjectInstance"
                                                                     [_flowInstance]="$model()"
                                                                     [_flowDefinition]="$model().flowDefinition"
                                                                     (_submitEvent)="executeTask($event)"
                                                        ></fob-approve>
                                                    }
                                                    @case (FlowObjectType.GatewayRules) {
                                                        <fob-gateway-rules [_model]="flowObjectInstance"
                                                        ></fob-gateway-rules>
                                                    }
                                                    @case (FlowObjectType.GatewayPaths) {
                                                        <fob-gateway-paths [_model]="flowObjectInstance"
                                                                           [_flowInstance]="$model()"
                                                                           [_flowDefinition]="$model().flowDefinition"
                                                                           (_submitEvent)="executeTask($event)"
                                                        ></fob-gateway-paths>
                                                    }
                                                    @case (FlowObjectType.Finish) {
                                                        <fob-finish [_model]="flowObjectInstance"
                                                                    [_flowInstance]="$model()"
                                                                    [_flowDefinition]="$model().flowDefinition"
                                                        ></fob-finish>
                                                    }
                                                    @case (FlowObjectType.FinishOutboundApi) {
                                                        <fob-outbound-api [_model]="flowObjectInstance"
                                                                          [_flowInstance]="$model()"
                                                                          [_flowDefinition]="$model().flowDefinition"
                                                                          (_modelChangeEvent)="outboundApiChangeHandler($event)"
                                                        ></fob-outbound-api>
                                                    }
                                                    @case (FlowObjectType.FinishContent) {
                                                        <fob-finish-content [_model]="flowObjectInstance"
                                                                            [_flowInstance]="$model()"
                                                                            [_flowDefinition]="$model().flowDefinition"
                                                                            (_submitEvent)="executeTask($event)"
                                                        ></fob-finish-content>
                                                    }
                                                    @case (FlowObjectType.CancelByDeliberation) {
                                                        <fob-cancel-by-deliberation [_model]="flowObjectInstance"
                                                                                    [_flowInstance]="$model()"
                                                                                    [_flowDefinition]="$model().flowDefinition"
                                                                                    (_submitEvent)="cancelByDeliberation($event)"
                                                                                    (_discardEvent)="discardManualCancel()"
                                                        ></fob-cancel-by-deliberation>
                                                    }
                                                    @case (FlowObjectType.CancelBySchedule) {
                                                        <fob-cancel-by-schedule [_model]="flowObjectInstance"
                                                                                [_flowInstance]="$model()"
                                                                                [_flowDefinition]="$model().flowDefinition"
                                                        ></fob-cancel-by-schedule>
                                                    }
                                                }
                                            </div>
                                        }
                                    }
                                </div>
                            </div>
                        }

                        <div class="btn-bar mt-4">
                            @if ($isFromConecta() && $isBootstrapFinished()) {
                                <!-- Botão para retorno ao Conecta ES -->
                                <a class="btn-wrapper return-to" href="//conecta.{{conectaEnvironmentSegment}}es.gov.br/servico/{{$model().flowDefinition.catalogServiceId}}">
                                    <div class="btn btn-outline-primary">
                                        <i class="fas fa-arrow-left mr-2"></i>
                                        <span>Voltar para o serviço</span>
                                    </div>
                                </a>
                            }

                            @if ($isEdocs()) {
                                <!-- Botão para retorno ao E-Docs -->
                                <div class="btn-wrapper return-to">
                                    <div class="btn btn-outline-primary" (click)="backToEdocs()" (keyDown)="backToEdocs()">
                                        <i class="fas fa-arrow-left mr-2"></i>
                                        <span>Voltar</span>
                                    </div>
                                </div>
                            }

                            @if ($canShowCancelButton()) {
                                <!-- Botão de cancelamento manual -->
                                <div class="btn-wrapper cancel">
                                    <div class="btn btn-outline-danger"
                                         matTooltip="Cancelar manualmente a Tarefa a ser executada (e, consequentemente, a instância de Fluxo)"
                                         (click)="cancelFlowInstanceByDeliberation()"
                                         (keyDown)="cancelFlowInstanceByDeliberation()"
                                    >
                                        <i class="fas fa-ban mr-1"></i>
                                        <span>Cancelar instância de Fluxo</span>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                }
            </div>
        </div>
    </div>
}
